import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import DateRangeSection
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/DateRangeSection';
import PerformanceChart
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/PerformanceChart';
import useMobileLayout from 'Hooks/useMobileLayout';


const useStyles = buildUseStyles('NonHighlightHeader', (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  chartContainer: {
    height: ({ isMobile }) => (isMobile ? 30 : 60),
    width: '100%',
    maxWidth: ({ isMobile }) => (isMobile ? 160 : 60),
  },
  nonHighlightedChart: {
    width: '100%',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
  },
}));

const NonHighlightHeader = ({
  className,
  label,
  chartData,
  startDate,
  endDate,
  onClickDateRange,
}) => {
  const isMobile = useMobileLayout();
  const classes = useStyles({ isMobile });

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box className={classes.leftColumn}>
        <Text variant={isMobile ? 'h3' : 'h6'} color={'black'} value={label} align={'left'} />
        {!isMobile && <DateRangeSection startDate={startDate} endDate={endDate} onClickDateRange={onClickDateRange} />}
      </Box>
      <Box className={classes.chartContainer}><PerformanceChart label={label} chartData={chartData} className={classes.nonHighlightedChart} /></Box>
    </Box>
  );
};

NonHighlightHeader.defaultProps = {
  className: '',
  chartData: undefined,
  onClickDateRange: undefined,
};

NonHighlightHeader.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  chartData: PropTypes.array,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onClickDateRange: PropTypes.func,
};

export default NonHighlightHeader;
